module.exports = __webpack_public_path__ + "img/buymeacoffe.fe79e50f.png";